import * as firebase from "firebase";
// import * as admin from "firebase-admin"

const devConfig = {
  apiKey: "AIzaSyCbWDhXP5RpHeRhuFYAf2TdB-nnfIzF7gQ",
  authDomain: "fourseasonsclimate.firebaseapp.com",
  databaseURL: "https://fourseasonsclimate.firebaseio.com",
  projectId: "fourseasonsclimate",
  storageBucket: "fourseasonsclimate.appspot.com",
  messagingSenderId: "841088366207"
};

const prodConfig = {
  apiKey: "AIzaSyCbWDhXP5RpHeRhuFYAf2TdB-nnfIzF7gQ",
  authDomain: "fourseasonsclimate.firebaseapp.com",
  databaseURL: "https://fourseasonsclimate.firebaseio.com",
  projectId: "fourseasonsclimate",
  storageBucket: "fourseasonsclimate.appspot.com",
  messagingSenderId: "841088366207"
};

const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

// const server = adminAccount ? adminAccount.auth() : null;
const auth = firebase.auth();
const db = firebase.database();
const functions = firebase.functions();
const store = firebase.firestore();

const settings = { timestampsInSnapshots: true };
store.settings(settings);

export { auth, db, functions, store };



// WEBPACK FOOTER //
// ./src/firebase/firebase.js